
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-should-login',
  templateUrl: './should-login.component.html',
  styleUrls: ['./should-login.component.scss']
})
export class ShouldLoginComponent {
  constructor(private oauthService: OAuthService,
    private router: Router) { }

  public login($event: any) {
    $event.preventDefault();
    this.router.navigate(['/']);
  }
}